export default function SEOHead({
  title,
  description,
  keywords,
  canonicalPath,
  ogType = "website",
  ogImage,
}: {
  title: string;
  description: string;
  keywords: string;
  canonicalPath: string;
  ogType?: string;
  ogImage?: string;
}) {
  const baseUrl = typeof window !== "undefined" ? window.location.origin + __BASE_PATH__ : "";
  const fullUrl = baseUrl + canonicalPath;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="本子漫画导航" />
      <meta property="og:locale" content="zh_CN" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </>
  );
}